import createReactComponent from '../createReactComponent';
export default createReactComponent('eye-check', 'IconEyeCheck', [
  ['path', { d: 'M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M11.102 17.957c-3.204 -.307 -5.904 -2.294 -8.102 -5.957c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a19.5 19.5 0 0 1 -.663 1.032',
      key: 'svg-1',
    },
  ],
  ['path', { d: 'M15 19l2 2l4 -4', key: 'svg-2' }],
]);
